function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from "react";
import Select from "react-select";

var PolizaPreviewForm = function PolizaPreviewForm(props) {
  var _poliza$commission;

  var poliza = props.poliza,
      _onChange = props.onChange,
      _props$insuranceBroke = props.insuranceBrokerAgents,
      insuranceBrokerAgents = _props$insuranceBroke === void 0 ? [] : _props$insuranceBroke;
  var options = insuranceBrokerAgents.map(function (agent) {
    return {
      label: "".concat(agent.full_name || "", " ").concat(agent.rut || "").trim() || "ID ".concat(agent.id),
      value: agent.id
    };
  });
  var executiveId = (_poliza$commission = poliza.commission) === null || _poliza$commission === void 0 ? void 0 : _poliza$commission.insurance_broker_executive_id;
  var selectedOption = executiveId != null ? options.find(function (o) {
    return o.value === executiveId;
  }) : null;
  return /*#__PURE__*/React.createElement("div", {
    className: "container-fluid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Minuta"), /*#__PURE__*/React.createElement("textarea", {
    className: "form-control",
    value: poliza.preview_notes,
    onChange: function onChange(event) {
      return _onChange(_objectSpread(_objectSpread({}, poliza), {}, {
        preview_notes: event.target.value
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Numero de cotizacion"), /*#__PURE__*/React.createElement("input", {
    className: "form-control",
    value: poliza.preview_quote_number,
    onChange: function onChange(event) {
      return _onChange(_objectSpread(_objectSpread({}, poliza), {}, {
        preview_quote_number: event.target.value
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Agente a cargo"), /*#__PURE__*/React.createElement(Select, {
    options: options,
    value: selectedOption,
    isClearable: true,
    isSearchable: true,
    placeholder: "Seleccionar agente",
    onChange: function onChange(option) {
      var agent = option ? insuranceBrokerAgents.find(function (a) {
        return a.id === option.value;
      }) : null;
      return _onChange(_objectSpread(_objectSpread({}, poliza), {}, {
        commission: _objectSpread(_objectSpread({}, poliza.commission), {}, {
          insurance_broker_executive_id: option ? option.value : null,
          insurance_broker_executive: agent ? {
            id: agent.id,
            full_name: agent.full_name,
            rut: agent.rut
          } : null
        })
      }));
    }
  }))));
};

export default PolizaPreviewForm;